import {
  Box,
  Divider,
  Heading,
  useColorMode,
  useColorModeValue,
  VStack,
} from '@chakra-ui/react';
import React from 'react';
import CommonAllergensFilter from './CommonAllergensFilter';
import IngredientFilter from './IngredientFilter';
import useOffGray from '../../../../common/hooks/useOffGrayColor';

const FilterBar = () => {
  const { offGray } = useOffGray();

  return (
    <Box
      w="300px"
      minHeight="100vh"
      p={5}
      pos={'fixed'}
      // bg={useColorModeValue('gray.50', 'gray.900')}
    >
      <Heading size="md" mb={5}>
        Filters
      </Heading>
      <Divider mb={10} />
      <VStack align="flex-start" spacing={10}>
        <IngredientFilter />
        <CommonAllergensFilter />
      </VStack>
    </Box>
  );
};

export default FilterBar;
